import classes from 'components/generics/flows/LoginSignUpFlow/SignUpFlow/components/SignUp/components/SignUpTerms/index.module.scss';
import Typography from 'components/generics/texts/Typography';
import { PRIVACY_POLICY_ROUTE, TERMS_ROUTE } from 'consts/routes/urls';
import Link from 'next/link';
import React, { HTMLAttributes } from 'react';

const SignUpTerms = ({ ...props }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div {...props}>
      <Typography className={classes.terms}>
        By clicking Create Account, you agree to the{' '}
        <Link
          className={classes.link}
          href={TERMS_ROUTE}
        >
          Terms
        </Link>{' '}
        and{' '}
        <Link
          className={classes.link}
          href={PRIVACY_POLICY_ROUTE}
        >
          Privacy Policy
        </Link>
        .
      </Typography>
    </div>
  );
};

export default SignUpTerms;
